import {Component, HostListener, Input, OnInit, Optional} from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import moment, { relativeTimeThreshold } from 'moment';
import { debounceTime } from 'rxjs';
import { CustomDateAdapter, CustomDateParserFormatter } from 'src/app/helpers/date-adapters';
import { BracketItemService } from 'src/app/services/bracket-item.service';
import { DuelSeriesService } from 'src/app/services/duel-series.service';
import {DuelViewsServiceService} from "../../services/duel-views-service.service";
import {PlayerReplacerService} from "../../services/player-replacer.service";
import {considerSettingUpAutocompletion} from "@angular/cli/src/utilities/completion";

const DUEL_SERIES_STATUS = {
  scheduled: 'Запланирована',
  in_progress: 'Идет игра',
  finished: 'Завершена',
};

@Component({
  selector: 'app-duel-series-view',
  templateUrl: './duel-series-view.component.html',
  styleUrls: ['./duel-series-view.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class DuelSeriesViewComponent implements OnInit {
  public id: number = -1;
  @Input() view: string = 'modal';
  @Input() externalId: number
  private returnId = () => this.id || this.externalId;
  public duelSeries: any = null;

  private _externalDuelIdItemKey: string = 'externalDuelIdItemKey';


  public is_staff: boolean = false;

  public result: string = '';

  public duelsInput: FormControl = new FormControl();
  public playerOneScore: FormControl = new FormControl();
  public playerTwoScore: FormControl = new FormControl();
  public winsCount: FormControl = new FormControl();
  public youtubeLink: FormControl = new FormControl();

  public DUEL_SERIES_STATUS = DUEL_SERIES_STATUS;

  public tables: any;

  public scheduledAtDate = null;
  public scheduledAtTime = null;

  private displayAdminPanelMobile : boolean = false;
  private duelAdminButtonText : string = 'Администрировать встречу';
  private isPC: boolean = window.innerWidth > 991;
  private duelPlayerDetailsOpened: boolean = false;
  private playerIdToShow: string = '';
  private playerPhoto;

  constructor(
    private duelSeriesService: DuelSeriesService,
    private bracketItemService: BracketItemService,
    private duelViewsService: DuelViewsServiceService,
    @Optional() private activeModal: NgbActiveModal,
    @Optional() private playerReplacerService: PlayerReplacerService,
  ) {}


  /**
   * Uploads a duel data: players score, youtube link, tables, and a duelSeries object
   */
  private duelDataRefresh = () => {
    console.debug('this is an externalId', this.externalId);
    this.duelSeriesService.get(this.returnId()).subscribe((ds) => {
      // @ts-ignore
      this.duelViewsService.duelCanBeReplayed = ds?.can_edit;
      this.duelSeries = ds;
      this.serialize();

      this.playerOneScore.setValue(this.getPlayerOneScore(), { emitEvent: false });
      this.playerTwoScore.setValue(this.getPlayerTwoScore(), { emitEvent: false });
      this.winsCount.setValue(this.duelSeries.wins_count, { emitEvent: false });
      this.youtubeLink.setValue(this.duelSeries.youtube_link, { emitEvent: false });

      this.duelSeriesService.getFreeTables(this.duelSeries.tournament_id).subscribe((tables) => {
        this.tables = tables;
      });
      this.playerReplacerService.listOfPlayersToIgnore = [this.duelSeries.player_one.full_name, this.duelSeries.player_two.full_name];
    });
  };

  private windowResizeEventHandler = () => {
    this.isPC = window.innerWidth > 991;
    if (this.isPC && this.adminPanelIsAvailable()) {
      this.displayAdminPanel();
      this.duelDataRefresh();
    }
  };

  getIsPC() {
    return this.isPC;
  }
  ngOnInit(): void {

    this.id = this.duelViewsService.duelId;

    console.debug('ngOnInit engaged!', this.id);

    if (this.returnId()) {
      window.localStorage.setItem(this._externalDuelIdItemKey, this.returnId().toString());
      console.debug('engaged local storage assign!');
    } else {
      console.debug('engaged local storage data retrieve!');
      console.debug('this is window item', window.localStorage.getItem(this._externalDuelIdItemKey));
      this.id = parseInt(window.localStorage.getItem(this._externalDuelIdItemKey));
      console.debug('id after retrieve!', this.id);
    }

    if (this.view == 'tablet' && !this.returnId()) {
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      return;
    }

    document.addEventListener('visibilitychange', this.duelDataRefresh);


    this.duelDataRefresh();

    this.duelViewsService.watchPlayersReplaceEventEmitter.subscribe((event) => {
      if (event === this.duelViewsService.updateDuePlayerReplace) {
        this.duelDataRefresh();
      }
    })
    // this.duelSeriesService.get(this.id).subscribe((ds) => {
    //   this.duelSeries = ds;
    //   this.serialize();
    //
    //   this.playerOneScore.setValue(this.getPlayerOneScore(), { emitEvent: false });
    //   this.playerTwoScore.setValue(this.getPlayerTwoScore(), { emitEvent: false });
    //   this.winsCount.setValue(this.duelSeries.wins_count, { emitEvent: false });
    //   this.youtubeLink.setValue(this.duelSeries.youtube_link, { emitEvent: false });
    //
    //   this.duelSeriesService.getFreeTables(this.duelSeries.tournament_id).subscribe((tables) => {
    //     this.tables = tables;
    //   });
    // });

    // @ts-ignore
    this.is_staff = window['iAmStaff'];

    this.duelsInput.valueChanges.subscribe((value) => {
      this.duelSeries.previewDuels = [];

      const duels = value.split(' ').map((duelScore: string, num: number) => {
        const score = duelScore.split('-');

        if (score.length != 2) {
          return null;
        }

        return {
          number: num + 1,
          player_one_score: parseInt(score[0]) || 0,
          player_two_score: parseInt(score[1]) || 0,
        };
      });

      this.duelSeries.previewDuels = duels.filter((item: any) => !!item);
    });

    this.playerOneScore.valueChanges.subscribe((value) => {
      this.duelSeries.player_one_score = parseInt(value);
      this.duelSeriesService.updateScore(this.returnId(), this.duelSeries.player_one_score, this.duelSeries.player_two_score).subscribe((ds) => {
        this.duelSeries = ds;
        this.serialize();
      });
    });

    this.playerTwoScore.valueChanges.subscribe((value) => {
      this.duelSeries.player_two_score = parseInt(value);
      this.duelSeriesService.updateScore(this.returnId(), this.duelSeries.player_one_score, this.duelSeries.player_two_score).subscribe((ds) => {
        this.duelSeries = ds;
        this.serialize();
      });
    });

    this.winsCount.valueChanges.subscribe((value) => {
      this.duelSeries.wins_count = parseInt(value);
      this.duelSeriesService.updateWinsCount(this.returnId(), this.duelSeries.wins_count).subscribe((ds) => {
        this.duelSeries = ds;
        this.serialize();
      });
    });

    this.youtubeLink.valueChanges.subscribe((value) => {
      this.duelSeries.youtube_link = value;
      this.duelSeriesService.updateYoutubeLink(this.returnId(), this.duelSeries.youtube_link).subscribe((ds) => {
        this.duelSeries = ds;
        this.serialize();
      });
    });

    window.addEventListener('resize', this.windowResizeEventHandler);
  }

  ngOnDestroy() :void {
    window.removeEventListener('resize', this.windowResizeEventHandler);
    this.playerReplacerService.formattedDictOfSubstitutes = {};
    // window.localStorage.removeItem(this._externalDuelIdItemKey);
    document.removeEventListener('visibilitychange', this.duelDataRefresh);
  }
  @HostListener('window:keydown', ['$event'])
  handleKeyPress(event: KeyboardEvent) {
    if (event.key == 'ArrowLeft') {
      this.incrementDuelSeriesScore(1);
    } else if (event.key == 'ArrowRight') {
      this.incrementDuelSeriesScore(2);
    }
  }

  controlsAvailable() {
    const userStatus = this.is_staff;
    const bothPlayersAreNotEmpty = !!(this.duelSeries.player_one && this.duelSeries.player_two);
    const duelIsNotFinished = this.duelSeries.status != 'finished';
    return duelIsNotFinished && userStatus && bothPlayersAreNotEmpty && this.duelCanBeReplayed(); // && !this.duelSeries.played_at;
  }

  serialize() {
    if (this.duelSeries.scheduled_at) {
      this.duelSeries.scheduled_at = new Date(this.duelSeries.scheduled_at);
    }
    if (this.duelSeries.played_at) {
      this.duelSeries.played_at = new Date(this.duelSeries.played_at);
    }

    this.duelSeries.table_number = this.duelSeries.table?.number;

    if (this.duelSeries.scheduled_at) {
      this.scheduledAtDate = moment(this.duelSeries.scheduled_at).format('DD.MM.YYYY');
      this.scheduledAtTime = {
        hour: parseInt(moment(this.duelSeries.scheduled_at).format('HH')),
        minute: parseInt(moment(this.duelSeries.scheduled_at).format('mm')),
      };
    }

    this.playerOneScore.setValue(this.duelSeries.player_one_score, { emitEvent: false });
    this.playerTwoScore.setValue(this.duelSeries.player_two_score, { emitEvent: false });
  }

  addDuel() {
    this.duelSeriesService.addDuel(this.returnId()).subscribe((duel) => {
      console.debug('request answer (ADD DUEL)!', duel);
      console.debug('duels arr before push', this.duelSeries.duels);
      this.duelSeries.duels.push(duel);
      console.debug('duels arr after push', this.duelSeries.duels);
    });
  }

  deleteDuel(id: number) {
    this.duelSeriesService.deleteDuel(this.returnId(), id).subscribe((response) => {
      this.duelSeries = response;
      this.serialize();
    });
  }

  open() {
    this.duelSeriesService.open(this.returnId()).subscribe((response) => {
      this.duelSeries = response;
      this.serialize();
    });
  }

  finish() {
    this.duelSeriesService.finish(this.returnId()).subscribe((response) => {
      this.duelSeries = response;
      this.serialize();
    });
  }

  incrementDuelSeriesScore(player_num: number) {
    this.duelSeriesService.incrementDuelSeriesScore(this.returnId(), player_num).subscribe((response) => {
      this.duelSeries = response;
      this.serialize();
      this.playerOneScore.setValue(this.getPlayerOneScore(), { emitEvent: false });
      this.playerTwoScore.setValue(this.getPlayerTwoScore(), { emitEvent: false });
    });
  }

  decrementDuelSeriesScore(player_num: number) {
    this.duelSeriesService.decrementDuelSeriesScore(this.returnId(), player_num).subscribe((response) => {
      this.duelSeries = response;
      this.serialize();
      this.playerOneScore.setValue(this.getPlayerOneScore(), { emitEvent: false });
      this.playerTwoScore.setValue(this.getPlayerTwoScore(), { emitEvent: false });
    });
  }

  incrementDuelScore(duel: any, player_num: number) {
    this.duelSeriesService.incrementDuelScore(this.returnId(), duel.id, player_num).subscribe((response) => {
      if (player_num == 1) {
        duel.player_one_score++;
      } else if (player_num == 2) {
        duel.player_two_score++;
      }
    });
  }

  decrementDuelScore(duel: any, player_num: number) {
    this.duelSeriesService.decrementDuelScore(this.returnId(), duel.id, player_num).subscribe((response) => {
      if (player_num == 1) {
        duel.player_one_score--;
      } else if (player_num == 2) {
        duel.player_two_score--;
      }
    });
  }

  save() {
    this.duelSeriesService.createDuels(this.returnId(), this.duelSeries.previewDuels).subscribe((ds) => {
      this.duelSeries = ds;
      this.serialize();
    });
  }

  getPlayerOneScore() {
    if (!this.duelSeries.previewDuels || (this.duelSeries.previewDuels && !this.duelSeries.previewDuels.length)) {
      return this.duelSeries.player_one_score;
    }

    const score = this.duelSeries.previewDuels.reduce((previousScore: number, duel: any) => {
      if (duel.player_one_score > duel.player_two_score) {
        return previousScore + 1;
      } else {
        return previousScore;
      }
    }, 0);
    return score;
  }

  getPlayerTwoScore() {
    if (!this.duelSeries.previewDuels || (this.duelSeries.previewDuels && !this.duelSeries.previewDuels.length)) {
      return this.duelSeries.player_two_score;
    }

    const score = this.duelSeries.previewDuels.reduce((previousScore: number, duel: any) => {
      if (duel.player_one_score < duel.player_two_score) {
        return previousScore + 1;
      } else {
        return previousScore;
      }
    }, 0);
    return score;
  }

  getPlayerOneNext() {
    if ((this.getPlayerOneScore() > this.getPlayerTwoScore() || !this.duelSeries.player_two) && this.duelSeries.winner_next) {
      return this.duelSeries.winner_next.number;
    } else if (this.getPlayerOneScore() < this.getPlayerTwoScore() && this.duelSeries.looser_next) {
      return this.duelSeries.looser_next.number;
    }
  }

  getPlayerTwoNext() {
    if ((this.getPlayerOneScore() < this.getPlayerTwoScore() || !this.duelSeries.player_one) && this.duelSeries.winner_next) {
      return this.duelSeries.winner_next.number;
    } else if (this.getPlayerOneScore() > this.getPlayerTwoScore() && this.duelSeries.looser_next) {
      return this.duelSeries.looser_next.number;
    }
  }

  triggerUpdate() {
    this.bracketItemService.update(this.returnId());
    if (this.duelSeries.child_ids) {
      this.duelSeries.child_ids.forEach((id) => {
        this.bracketItemService.update(id);
      });
    }
  }

  getStatus() {
    return DUEL_SERIES_STATUS[this.duelSeries.status];
  }

  goto(next) {
    if (this.activeModal) {
      this.activeModal.close();
      this.bracketItemService.scrollTo(next);
    }
  }

  /**
   * Shuts down an open modal
   * by clicking cross button
   */
  onClickModalShutter() : void {
    if (this.activeModal && Object.keys(this.activeModal).length) {
      this.activeModal.close();
    } else {
      document.getElementById('modal' + this.returnId()).click();
    }

  }

  start() {
    this.duelSeriesService.updateStatus(this.returnId(), 'in_progress').subscribe((ds) => {
      this.duelSeries = ds;
      this.serialize();
    });
  }

  pause() {
    this.open();
  }

  stop() {
    if (this.duelSeries.player_one_score == this.duelSeries.player_two_score) {
      alert('Встреча не может быть завершена с равным счетом');
    } else {
      this.finish();
    }
  }

  assignTable($event) {
    this.duelSeriesService.assignTable(this.returnId(), $event.target.value).subscribe((ds) => {
      this.duelSeries = ds;
      this.serialize();
    });
  }

  saveScheduledTime() {
    if (!this.scheduledAtDate || !this.scheduledAtTime) {
      alert('Не указана дата или время');
      return;
    }

    const scheduled = new Date();
    const splitted = this.scheduledAtDate.split('.');
    scheduled.setDate(splitted[0]);
    scheduled.setMonth(splitted[1] - 1);
    scheduled.setFullYear(splitted[2]);
    scheduled.setHours(this.scheduledAtTime.hour);
    scheduled.setMinutes(this.scheduledAtTime.minute);

    this.duelSeriesService.updateSchedule(this.returnId(), new Date(scheduled.getTime() - scheduled.getTimezoneOffset() * 60000)).subscribe((ds) => {
      this.duelSeries = ds;
      this.serialize();
      this.activeModal.close();
    });
  }

  /**
   * In charge of displaying or hiding
   * admin panel and duel info by click
   */
  displayAdminPanel() : void {
    this.displayAdminPanelMobile = !this.displayAdminPanelMobile;
    this.duelAdminButtonText = this.displayAdminPanelMobile ? 'Завершить администрирование' : 'Администрировать встречу'
  }

  /**
   * Returns the flag that states
   * whether the admin component is accessible or not
   */
  adminPanelIsAvailable() : boolean {
    return this.displayAdminPanelMobile;
  }

  /**
   * Returns actual admin button text
   */
  getAdminButtonText () : string {
    return this.duelAdminButtonText;
  }

  /**
   * rules display or hide scores and corresponding labels
   */
  showDuelScore() : boolean {
    const appropriateStatus =
      this.duelSeries.status === 'in_progress'
      || this.duelSeries.status === 'finished'; // убрано требование на наличие статуса "scheduled", присутствие этого требования
                                                // приводило к появлению счёта для запланированной встречи
    const playersAreNotEmpty = !!(this.duelSeries.player_one && this.duelSeries.player_two);
    const userStatus = this.is_staff;

    if (!playersAreNotEmpty) {
      return false;
    }
    return appropriateStatus || userStatus;
  }

  /**
   *
   * defines whether duel player details are opened or not
   */
  setDuelPlayerDetailsOpened (): void {
    this.duelPlayerDetailsOpened = !this.duelPlayerDetailsOpened;
  }

  /**
   * returns boolean flag in charge of duel player data displaying
   */
  getDuelPlayerDetailsOpened () : boolean {
    return this.duelPlayerDetailsOpened;
  }

  /**
   *
   * @param fullName - event.target.innerText to clarify which player id to send
   */
  setPlayerIdToShow(fullName) : void {
    if (fullName === this.duelSeries?.player_one?.full_name) {
      this.playerIdToShow = this.duelSeries.player_one.id;
      this.setPlayerPhoto(this.duelSeries.player_one.image);

    } else if (fullName === this.duelSeries?.player_two?.full_name){
      this.playerIdToShow = this.duelSeries.player_two.id;
      this.setPlayerPhoto(this.duelSeries.player_two.image);

    }
  }

  setPlayerPhoto(image) : void {
    this.playerPhoto = image;
  }

  getPlayerPhoto() {
    return this.playerPhoto;
  }

  /**
   * Returns player id to show
   */
  getPlayerIdToShow() : string {
    return this.playerIdToShow;
  }

  playerNameLinkClickHandler(event) : void {
    const fullName = event.target.innerText;
    this.setPlayerIdToShow(fullName);
    this.setDuelPlayerDetailsOpened();
  }

  hideAdminPanelForEmptyPlayer() {
    return !!(this.duelSeries.player_one && this.duelSeries.player_two);
  }

  hideAdminPanelForNoOnePlayer() {
    return !!(this.duelSeries.player_one || this.duelSeries.player_two);
  }

  duelCanBeReplayed(): boolean {
    return this.duelViewsService.duelCanBeReplayed;
  }
}
